import { ClientLocation } from "Util/clientLocation";

export async function geocodeAddressUsingAzureMaps($app, address, sasToken) {
    try {
        const locale = $app.DateCultureMessageInfo.Locale;
        const encodedAddress = encodeURIComponent(address);
        const url = `https://atlas.microsoft.com/search/address/json?api-version=1.0&language=${locale}&query=${encodedAddress}`;
        const authHeader = "jwt-sas " + sasToken;
        const response = await fetch(url, {
            headers: {
                Authorization: authHeader
            }
        });

        const data = await response.json();
        const point = data.results[0].position;
        // point.lat and point.lon
        const clientLocation = new ClientLocation(point.lon, point.lat);
        return clientLocation;
    } catch (error) {
        console.error("Error geocoding address:", error);
    }
    return null;
}
